export const InstoreServicesRoutes = [
	'/uslugi/analiz-vody/',
	'/uslugi/analiz-vody/:shop',
	'/uslugi/kolerovka/',
	'/uslugi/kolerovka/:shop',
	'/uslugi/overlok/',
	'/uslugi/overlok/:shop',
	'/uslugi/poshiv-shtor/',
	'/uslugi/poshiv-shtor/:shop',
	'/uslugi/rezka-dereva/',
	'/uslugi/rezka-dereva/:shop',
	'/uslugi/rezka-stekla/',
	'/uslugi/rezka-stekla/:shop',
];
